const getters = {
    currencyConversionTable: state => state.currencyConversionTable,
    visitorCurrency: state => state.visitorCurrency,
};

export default getters;